export const settings = {
  title: 'Settings',

  baby: {
    title: 'Baby & family',
    nickname: 'Baby nickname',
    nicknamePlaceholder: 'e.g. Peanut',
    birthDate: 'Birth date & time',
    dueDate: 'Due date',
    birthWeight: 'Birth weight',
    feedingGoals: 'Feeding goals',
    feedingGoalsPlaceholder: 'What feels right for your family? Combination feeding counts too.',
    waitingForSync:
      'These details arrive automatically from the other phone after the first sync.',
  },

  units: {
    lb: 'lb',
    oz: 'oz',
    g: 'g',
  },

  prefs: {
    title: 'Preferences',
    language: 'Language',
    english: 'English',
    spanish: 'Español',
    volumeUnit: 'Bottle amounts',
    oz: 'oz',
    ml: 'ml',
    weightUnit: 'Weight',
    lboz: 'lb + oz',
    grams: 'grams',
    theme: 'Appearance',
    themeAuto: 'Auto',
    themeLight: 'Light',
    themeDark: 'Dark',
    accent: 'Color',
    accentNames: {
      purple: 'Purple',
      blue: 'Blue',
      teal: 'Teal',
      rose: 'Rose',
      clay: 'Clay',
    },
  },

  partner: {
    title: 'Partner connection',
  },

  install: {
    title: 'Add to home screen',
    intro: 'Keep First Weeks one tap away, even at 3am. Once installed, it works offline too.',
    ios: 'iPhone or iPad (Safari)',
    iosSteps: [
      'Open this page in Safari.',
      'Tap the options menu (•••) in the address bar. On older iPhones the Share button sits in the toolbar instead, so you can skip to the next step.',
      'Choose Share (the square with an arrow pointing up).',
      'Scroll down, tap "Add to Home Screen", then tap Add.',
    ],
    android: 'Android (Chrome)',
    androidSteps: [
      'Open this page in Chrome.',
      'Tap the three-dot menu in the top corner.',
      'Tap "Add to Home screen" (or "Install app"), then confirm.',
    ],
    finePrint:
      'Installing this way comes straight from your pediatrician rather than through the App Store or Google Play. There is no store account, nothing to download, and no store record of what you installed. Your log lives on your phone and stays yours, and updates arrive on their own the next time you open it.',
  },

  about: {
    title: 'About',
    call: 'Call the office',
    website: 'Visit our website',
    privacy: 'Privacy notice',
    erase: 'Erase all data',
    eraseWarning:
      'This permanently deletes everything on this phone: every feeding, diaper, weight, and setting. If you are connected with a partner, their phone keeps its own copy. This cannot be undone.',
    eraseConfirm: 'Yes, erase everything',
  },
};
